export function formatDurationClock(seconds: number | null | undefined): string {
  if (!Number.isFinite(seconds) || (seconds ?? 0) < 0) return '0:00';
  const wholeSeconds = Math.floor(seconds ?? 0);
  const minutes = Math.floor(wholeSeconds / 60);
  const remainder = wholeSeconds % 60;
  return `${minutes}:${remainder.toString().padStart(2, '0')}`;
}

export function formatDurationLabel(
  estimatedMinutes: number | null | undefined,
  outputSeconds?: number | null
): string | null {
  if (Number.isFinite(outputSeconds) && (outputSeconds ?? 0) >= 0) {
    const roundedMinutes = Math.max(1, Math.round((outputSeconds ?? 0) / 60));
    return `${roundedMinutes} min`;
  }
  if (Number.isFinite(estimatedMinutes) && (estimatedMinutes ?? 0) >= 0) {
    return `About ${Math.round(estimatedMinutes ?? 0)} min`;
  }
  return null;
}
